import type { AspectRatio } from '@uncinc/react-drupal-core/dist/Components/DynamicMediaItem';

import type {
  SearchAllContentHit,
  SearchAllContentNodeImageRatio,
  SearchAllContentProfileImageRatio,
  SearchAllContentTaxonomyImageRatio,
} from '../components/SearchAllContent/types';

import {
  SCREEN_XS,
  SCREEN_SM,
  SCREEN_MD,
  SCREEN_LG,
  SCREEN_XL,
} from '../config/constants';

function constructVariableRatiosImageSourcesObject(
  hit: SearchAllContentHit,
  aspectRatio: [AspectRatio, AspectRatio, AspectRatio, AspectRatio, AspectRatio],
  cropSizes: [string, string, string, string, string] = ['xxs', 'xs', 'sm', 'md', 'md'],
) {
  // For indexing image ratios, we use custom fields in the ES index.
  // The tokens for this differ between entity type.

  // Nodes.
  if ('image_ratio_1_1_xxs' in hit) {
    return {
      [SCREEN_XS]: (hit[`image_ratio_${aspectRatio[0]}_${cropSizes[0]}` as SearchAllContentNodeImageRatio])?.[0] ?? '',
      [SCREEN_SM]: (hit[`image_ratio_${aspectRatio[1]}_${cropSizes[1]}` as SearchAllContentNodeImageRatio])?.[0] ?? '',
      [SCREEN_MD]: (hit[`image_ratio_${aspectRatio[2]}_${cropSizes[2]}` as SearchAllContentNodeImageRatio])?.[0] ?? '',
      [SCREEN_LG]: (hit[`image_ratio_${aspectRatio[3]}_${cropSizes[3]}` as SearchAllContentNodeImageRatio])?.[0] ?? '',
      [SCREEN_XL]: (hit[`image_ratio_${aspectRatio[4]}_${cropSizes[4]}` as SearchAllContentNodeImageRatio])?.[0] ?? '',
    };
  }

  // Taxonomy terms.
  if ('taxonomy_teaser_image_ratio_1_1_xxs' in hit) {
    return {
      [SCREEN_XS]: (hit[`taxonomy_teaser_image_ratio_${aspectRatio[0]}_${cropSizes[0]}` as SearchAllContentTaxonomyImageRatio])?.[0] ?? '',
      [SCREEN_SM]: (hit[`taxonomy_teaser_image_ratio_${aspectRatio[1]}_${cropSizes[1]}` as SearchAllContentTaxonomyImageRatio])?.[0] ?? '',
      [SCREEN_MD]: (hit[`taxonomy_teaser_image_ratio_${aspectRatio[2]}_${cropSizes[2]}` as SearchAllContentTaxonomyImageRatio])?.[0] ?? '',
      [SCREEN_LG]: (hit[`taxonomy_teaser_image_ratio_${aspectRatio[3]}_${cropSizes[3]}` as SearchAllContentTaxonomyImageRatio])?.[0] ?? '',
      [SCREEN_XL]: (hit[`taxonomy_teaser_image_ratio_${aspectRatio[4]}_${cropSizes[4]}` as SearchAllContentTaxonomyImageRatio])?.[0] ?? '',
    };
  }

  // Profiles.
  if ('profile_image_ratio_1_1_xxs' in hit) {
    return {
      [SCREEN_XS]: (hit[`profile_image_ratio_${aspectRatio[0]}_${cropSizes[0]}` as SearchAllContentProfileImageRatio])?.[0] ?? '',
      [SCREEN_SM]: (hit[`profile_image_ratio_${aspectRatio[1]}_${cropSizes[1]}` as SearchAllContentProfileImageRatio])?.[0] ?? '',
      [SCREEN_MD]: (hit[`profile_image_ratio_${aspectRatio[2]}_${cropSizes[2]}` as SearchAllContentProfileImageRatio])?.[0] ?? '',
      [SCREEN_LG]: (hit[`profile_image_ratio_${aspectRatio[3]}_${cropSizes[3]}` as SearchAllContentProfileImageRatio])?.[0] ?? '',
      [SCREEN_XL]: (hit[`profile_image_ratio_${aspectRatio[4]}_${cropSizes[4]}` as SearchAllContentProfileImageRatio])?.[0] ?? '',
    };
  }

  return '';
}

export default constructVariableRatiosImageSourcesObject;
